module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<% if (section.id == 0) { %>\n    <span class="planning_header" id="tot">Tôt</span>\n<% } else if (section.id == 1) { %>\n    <span class="planning_header" id="matin">Matin</span>\n<% } else if (section.id == 2) { %>\n    <span class="planning_header" id="midi">Midi</span>\n<% } else if (section.id == 3) { %>\n    <span class="planning_header" id="apres-midi">Après-midi</span>\n<% } else if (section.id == 4) { %>\n    <span class="planning_header" id="soir">Soir</span>\n<% } else { %>\n    <span class="planning_header"><%= section.id %></span>\n<% } %>\n\n<div class="planning_parts"></div>\n',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push("");
                __stack.lineno = 1;
                if (section.id == 0) {
                    buf.push('\n    <span class="planning_header" id="tot">Tôt</span>\n');
                    __stack.lineno = 3;
                } else if (section.id == 1) {
                    buf.push('\n    <span class="planning_header" id="matin">Matin</span>\n');
                    __stack.lineno = 5;
                } else if (section.id == 2) {
                    buf.push('\n    <span class="planning_header" id="midi">Midi</span>\n');
                    __stack.lineno = 7;
                } else if (section.id == 3) {
                    buf.push('\n    <span class="planning_header" id="apres-midi">Après-midi</span>\n');
                    __stack.lineno = 9;
                } else if (section.id == 4) {
                    buf.push('\n    <span class="planning_header" id="soir">Soir</span>\n');
                    __stack.lineno = 11;
                } else {
                    buf.push('\n    <span class="planning_header">', escape((__stack.lineno = 12, section.id)), "</span>\n");
                    __stack.lineno = 13;
                }
                buf.push('\n\n<div class="planning_parts"></div>\n');
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// /home/app/terminal/release/1714127418-2.1.11/node_modules/ejs-compiled-loader!./src/templates/main_section.ejs
// module id = 140
// module chunks = 0